module.exports = __webpack_public_path__ + "img/offer-call-in.8c88353e.svg";